import { render } from "./BNumberInput.vue?vue&type=template&id=24ed4106&scoped=true&ts=true"
import script from "./BNumberInput.vue?vue&type=script&lang=ts"
export * from "./BNumberInput.vue?vue&type=script&lang=ts"

import "./BNumberInput.vue?vue&type=style&index=0&id=24ed4106&scoped=true&lang=css"

import exportComponent from "/Users/malo/Documents/lamasign/be-right-vue3-lib 15.25.31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ed4106"]])

export default __exports__